import { Table, TableContainer, Tr, Tbody, Td, Box } from "@chakra-ui/react"

import { convertToWords, formatCurrency } from "@/utils/currency";
import { CURRENCY } from "@/common/constants";

interface TableInformationInspectionFeeProps {
    fee: number,
    awaitingDaysFee: number,
    isTC: boolean,
};

const TableInformationInspectionFee = ({ fee, awaitingDaysFee, isTC }: TableInformationInspectionFeeProps) => {
    if (isTC) {
        return (
            <TableContainer bgColor="#fff" borderRadius="13">
                <Box overflowX="auto">
                  <Table variant="simple">
  <Tbody>
    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        INSPECTION FEES
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        The FEE for this inspection is {convertToWords(fee, CURRENCY.USD.name)} ({formatCurrency(fee, 'USD', 'en-US')}).
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        Once the inspector has commenced travel to the vessel, any delays to the scheduled inspection will be charged at an additional {convertToWords(awaitingDaysFee, CURRENCY.USD.name)} ({formatCurrency(awaitingDaysFee, 'USD', 'en-US')}) per day.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        If the Inspector is unable to disembark the vessel on completion due to safety or operational reasons, an additional {convertToWords(awaitingDaysFee, CURRENCY.USD.name)} ({formatCurrency(awaitingDaysFee, 'USD', 'en-US')}) per day will be applied.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        For cases when the inspector has already left home to reach the vessel, a cancellation fee of Two Thousand USD (2000.00 USD) plus travel expense at cost will be applied for SIRE 2.0 and One Thousand USD (1000.00 USD) plus travel expense at cost will be applied for BIRE.
        This is due to the potential decline of other inspection opportunities to accommodate your request, necessitating compensation for the inspector's expended efforts and time.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        The owners/operators are also responsible for arranging as necessary all the following means: launch services, helicopters, agent's fees, clearance fees, access permits or similar and all related costs will be settled by the vessel's nominated representative.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        If nothing is heard from you with regard to these T&amp;C, and the inspector has completed the inspection, we assume that you agree with the terms and conditions set herein.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        Please include into your payment details the following information:<br />
        "OUR INVOICE NUMBER"
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        Kindly note that your bank should be instructed to settle in full, bank charges being for the sender's account.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        Please revert with Invoice details if not mentioned on the request, payment at seven (7) days from the date of the invoice.
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        To ensure maximum cybersecurity, please note that our sole and exclusive bank details are as follows:
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        Beneficiary: <strong>PT. PERTAMINA MARINE SOLUTIONS</strong><br />
        Bank name: <strong>BANK BNI</strong><br />
        IBAN: <strong>-</strong><br />
        SWIFT: <strong>BNINIDJAXXX</strong><br />
        Account Number: <strong>7272828273 (IDR Accounts)</strong>
      </Td>
    </Tr>

    {/* === NEW SECTION STARTS HERE === */}

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        For clarity and effective coordination, please find below the designated points of contact for inspection matters and invoicing, categorized based on vessel type:
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        <strong>TC Vessel</strong><br />
        PIC Inspection: annisa.islamia@pertamina.com<br />
        cc :sire.pmsol@pertamina.com<br />
        Invoicing TC: mk.raja.daniel@mitrakerja.pertamina.com
      </Td>
    </Tr>

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        <strong>3rd Party Vessel</strong><br />
        PIC Inspection: harizaputra@pertamina.com<br />
        cc :sire.pmsol@pertamina.com<br />
        Invoicing 3rd Party: aldrian.sinuraya@pertamina.com
      </Td>
    </Tr>

    {/* === NEW SECTION ENDS HERE === */}

    <Tr>
      <Td whiteSpace="normal" wordBreak="break-word">
        Kindly refer strictly to this information in all future transactions.
      </Td>
    </Tr>
  </Tbody>
</Table>

                </Box>
            </TableContainer>
        )
    }

    // else if 3rd
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Tbody>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                Overnight inspection is strongly discouraged for safety reasons.
                                Inspections in darkness will only be conducted in exceptional circumstances with appropriate control measures, it is a must that rest and working hours policy as per STCW will be in compliance.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                INSPECTION FEES
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                The FEE for this inspection is {convertToWords(fee)} USD ({formatCurrency(fee, 'USD', 'en-US')}) plus expenses.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                Once the inspector has commenced travel to the vessel, any delays to the scheduled inspection will be charged at an additional {convertToWords(awaitingDaysFee)} USD ({formatCurrency(awaitingDaysFee, 'USD', 'en-US')}) per day.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                If the Inspector unable to disembark the vessel on completion due to safety or operational reasons an additional {convertToWords(awaitingDaysFee)} USD ({formatCurrency(awaitingDaysFee, 'USD', 'en-US')}) per day will be applied.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                If the Vessel's inspection is cancelled before the inspector commenced traveling, the cancellation fee will be One Thousand USD (1000.00 USD), due to SIRE 2.0 regime required inspector to review the CVIQ before board the Vessel.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                For cases when the inspector has already left home to reach the vessel, a cancellation fee of : Two Thousand USD (2000.00 USD) plus travel expense at cost will be applied for SIRE 2.0 and One Thousand USD (1000.00 USD) Plus travel expense at cost will be applied for BIRE.
                                This is due to the potential decline of other inspection opportunities to accommodate your request, necessitating compensation for the inspector's expended efforts and time.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                The owners/operators are also responsible for arranging as necessary all the following means: launch services, helicopters, agent's fees, clearance fees, access permits or similar and all related costs will be settled by the vessel's nominated representative.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                If nothing is heard from you with regard to these T&C, and the inspector has completed the inspection, we assume that you agree with the terms and conditions set herein.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                Please include into your payment details the following information:<br />
                                "OUR INVOICE NUMBER"
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                Kindly note that your bank should be instructed to settle in full, bank charges being for the sender's account.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                Please revert with Invoice details if not mentioned on the request, payment at seven (7) days from the date of the invoice.
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                To ensure maximum cybersecurity, please note that our sole and exclusive bank details are as follows:
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal">
                                Beneficiary: <strong>PT PERTAMINA MARINE SOLUTIONS</strong><br />
                                Bank name: <strong>BANK MANDIRI</strong><br />
                                IBAN: <strong>-</strong><br />
                                SWIFT:  <strong>BMRIIDJA</strong><br />
                                ACCOUNT NO: <strong>1250015035827</strong> (USD)
                            </Td>
                        </Tr>
                        <Tr>
                            <Td whiteSpace="normal" wordBreak="break-word">
                                Kindly refer strictly to this information in all future transactions.
                            </Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>
        </TableContainer>
    )
}

export default TableInformationInspectionFee;
